import { createElementBlock as o, openBlock as t, createElementVNode as e } from "vue";
import a from "./index289.js";
const n = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(l, c, p, m, _, d) {
  return t(), o("svg", r, c[0] || (c[0] = [
    e("path", { d: "m32.599 14.082.009.011.267.273A11.298 11.298 0 0 1 35.61 19.3c3.505-.65 7.257.32 10.028 2.911l.222.214.013.012a11.315 11.315 0 0 1 0 16.126c-3.034 3-7.426 4.03-11.403 2.864a11.308 11.308 0 0 1-3.08 5.49c-4.492 4.444-11.772 4.444-16.266 0a11.317 11.317 0 0 1 0-16.125c.306-.302.624-.583.953-.844a11.317 11.317 0 0 1 .255-15.866c4.492-4.443 11.773-4.443 16.266 0ZM16.883 32.57a8.817 8.817 0 0 0 0 12.57c3.52 3.481 9.231 3.481 12.75 0a8.814 8.814 0 0 0 .203-12.363l-.203-.207-.21-.2c-3.532-3.278-9.09-3.211-12.54.2Zm14.483-8.354a8.82 8.82 0 0 0-2.469 4.588l-.024.1c.902.5 1.75 1.13 2.518 1.889a11.3 11.3 0 0 1 3.376 8.104c3.222 1.114 6.869.342 9.349-2.11a8.815 8.815 0 0 0 0-12.57c-3.52-3.482-9.23-3.482-12.75-.001ZM18.091 15.86a8.817 8.817 0 0 0 0 12.57c.053.053.101.11.143.169a11.652 11.652 0 0 1 8.295-.672 11.32 11.32 0 0 1 3.08-5.49 11.482 11.482 0 0 1 3.604-2.417 8.796 8.796 0 0 0-2.373-4.16l-.01-.011-.199-.19c-3.532-3.278-9.09-3.21-12.54.2Z" }, null, -1)
  ]));
}
const u = /* @__PURE__ */ a(n, [["render", s]]);
export {
  u as default
};
